import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import './CommunityGuidelines.css';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';

function CommunityGuidelines() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <HomeNav />
            <div className="community-guidelines-container">
                <h2 className="community-guidelines-title">Community Guidelines – Astra Clean</h2>
                <p className="community-guidelines-intro">
                    At <strong>Astra Clean</strong>, we aim to create a respectful, safe, and positive community for our customers, staff, and partners. 
                    These guidelines help ensure a smooth and pleasant experience for everyone who interacts with our services and platforms.
                </p>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">🤝 Respect & Professionalism</h3>
                    <p className="community-guidelines-text">
                        We expect all users, customers, and staff to communicate respectfully. Harassment, abusive language, discrimination, 
                        or inappropriate behavior toward our team or other customers will not be tolerated.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">🧑‍💼 Fair Use of Services</h3>
                    <p className="community-guidelines-text">
                        Our services should be used responsibly and for their intended purposes only. Any misuse of services, false bookings, 
                        or misleading information may result in service refusal.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">🏠 Safe & Appropriate Environment</h3>
                    <p className="community-guidelines-text">
                        Customers are expected to provide a safe and accessible environment for our cleaning professionals. Any conditions that 
                        may pose a risk to health or safety should be disclosed in advance.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">🗣️ Honest Communication</h3>
                    <p className="community-guidelines-text">
                        Clear and honest communication helps us deliver the best service. Please provide accurate details about your cleaning needs, 
                        location, and special requests when booking.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">🔐 Privacy & Confidentiality</h3>
                    <p className="community-guidelines-text">
                        Respect for privacy is essential. Sharing personal, private, or sensitive information about Astra Clean staff or other customers 
                        without consent is strictly prohibited.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">📅 Appointments & Scheduling</h3>
                    <p className="community-guidelines-text">
                        We kindly ask customers to respect scheduled appointments. While cancellations are not available due to our quick response time, 
                        rescheduling is allowed in accordance with our policies.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">⚠️ Reporting Concerns</h3>
                    <p className="community-guidelines-text">
                        If you experience any issues, concerns, or guideline violations, please report them through our official support channels. 
                        We are committed to addressing concerns fairly and promptly.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">🚫 Policy Violations</h3>
                    <p className="community-guidelines-text">
                        Failure to follow these Community Guidelines may result in warnings, suspension of services, or permanent refusal of service, 
                        depending on the severity of the issue.
                    </p>
                </div>

                <div className="community-guidelines-section">
                    <h3 className="community-guidelines-section-title">🌟 Our Commitment</h3>
                    <p className="community-guidelines-text">
                        Astra Clean is committed to maintaining a welcoming and trustworthy community built on respect, safety, and transparency. 
                        By using our services, you agree to follow these guidelines and help us create a better experience for everyone.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default CommunityGuidelines;
